(ns utility-belt.uuid
  (:refer-clojure :exclude [uuid uuid?])
  #?(:cljs
     (:require [cognitect.transit :as transit]))
  #?(:clj (:import [java.util UUID])))

(def generate-uuid
  "Returns a random UUID"
  #?(:cljs random-uuid
     :clj #(UUID/randomUUID)))

(def uuid-from-string
  #?(:cljs cljs.core/uuid
     :clj  #(UUID/fromString %)))

(def uuid?
  #?(:clj clojure.core/uuid?
     :cljs transit/uuid?))

(defn uuid
  "Returns a random UUID string"
  []
  #?(:clj (.toString (UUID/randomUUID))
     :cljs (str (random-uuid))))

(def uuid-pattern "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}")

(def uuid-regex
  "This regex matches any string that contains a uuid pattern and should be used in route matching"
  (re-pattern uuid-pattern))

(let [uuid-regex (re-pattern (str "^" uuid-pattern "$"))]
  (defn uuid-string?
    "This fn tests whether the supplied string is a uuid"
    [s]
    (-> (and (string? s)
             (re-find uuid-regex s))
        boolean)))

(defn first-uuid
  "Returns the first uuid found in the given string or nil if none exists"
  [string]
  (re-find uuid-regex string))

(defn uuid->str
  "If the supplied value is a UUID convert it to a String representation of that
  UUID, otherwise return the value unchanged"
  [v]
  (cond-> v (uuid? v) str))

(defn str->uuid
  "If the supplied value is a String representation of a UUID convert it to a
  UUID, otherwise return the value unchanged"
  [v]
  (cond-> v (uuid-string? v) uuid-from-string))
